// src/hooks/useAnalytics.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, trackTabView } from "../lib/analytics";

/** Track URL route changes (public pages, login, etc.) */
export function usePageViewTracking() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
}

/** Track tab changes inside the main app */
export function useTabTracking(activeTab) {
  useEffect(() => {
    if (activeTab) trackTabView(activeTab);
  }, [activeTab]);
}
